import React from 'react'
import Chip from '@mui/material/Chip'
import HowToRegIcon from '@mui/icons-material/HowToReg'
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread'
import NearbyErrorIcon from '@mui/icons-material/NearbyError'
import RuleIcon from '@mui/icons-material/Rule'
import NewspaperIcon from '@mui/icons-material/Newspaper'
import { Tooltip, Zoom } from '@mui/material'

interface ComponentProps {
  registrationState: string
}

export const RegistrationStatusChip: React.FC<ComponentProps> = ({ registrationState }: ComponentProps): JSX.Element => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (registrationState === 'AWAITING_EMAIL_CONFIRMATION') {
    color = 'error'
    variant = 'outlined'
  } else if (registrationState === 'PARTIALLY_REGISTERED') {
    color = 'warning'
    variant = 'outlined'
  } else if (registrationState === 'SUBSCRIBED_TO_NEWSLETTER') {
    color = 'secondary'
    variant = 'outlined'
  } else if (registrationState === 'REGISTERED') {
    color = 'primary'
    variant = 'outlined'
  }

  const statusIcon = (status: string): JSX.Element => {
    if (status === 'AWAITING_EMAIL_CONFIRMATION') {
      return <MarkEmailUnreadIcon />
    } else if (status === 'PARTIALLY_REGISTERED') {
      return <RuleIcon />
    } else if (status === 'SUBSCRIBED_TO_NEWSLETTER') {
      return <NewspaperIcon />
    } else if (status === 'REGISTERED') {
      return <HowToRegIcon />
    } else {
      return <NearbyErrorIcon />
    }
  }

  return (
    <Tooltip title={registrationState} TransitionComponent={Zoom} arrow placement='bottom'>
      {variant === undefined || variant === null
        ? (
          <Chip icon={statusIcon(registrationState)} label={registrationState} color={color}></Chip>
          )
        : (
          <Chip icon={statusIcon(registrationState)} label={registrationState} variant={variant} color={color} />
          )
      }
    </Tooltip>
  )
}
